module.exports = __webpack_public_path__ + "static/media/48.3a3d0cc4.jpg";